import { urls } from 'utils/urls';

import { buildApiRequest } from 'utils/api';

export function getAddressDetailsRequest(demandId) {
  return buildApiRequest('GET', `${urls.getDemands}/${demandId}/address`);
}
export function getAddressDetailsRequestV4(demandId) {
  return buildApiRequest('GET', `${urls.getAddressV4}/${demandId}/addresses`);
}
export function patchAddressV4(addressId, payload) {
  return buildApiRequest('PATCH', `${urls.patchAddress}/${addressId}`, payload);
}
export function deleteAddressV4(addressId) {
  return buildApiRequest('DELETE', `${urls.patchAddress}/${addressId}`);
}
export function addAddresses(demandId, payload) {
  return buildApiRequest('PUT', `${urls.getAddressV4}/${demandId}/addresses`, payload);
}
export function getViaPointsRequest(params) {
  return buildApiRequest('GET', `${urls.viaPoints}`, params.params);
}

export function createViaPointRequest(payload) {
  return buildApiRequest('POST', `${urls.createViaPoint}`, payload.payload);
}

export function editViaPointRequest(payload) {
  return buildApiRequest('PUT', `${urls.createViaPoint}`, payload.payload);
}

export function createNewAddressRequest(payload) {
  return buildApiRequest('POST', urls.createConsignerAddress, payload.payload);
}

export function editAddressRequest(payload) {
  return buildApiRequest('PUT', urls.saveConsignerAddress, payload.payload);
}

export function deleteViaPointRequest(params) {
  return buildApiRequest('DELETE', `${urls.createViaPoint}`, params.params);
}

export function deletePocRequest(params) {
  return buildApiRequest('DELETE', urls.deletePoc, params.params);
}

export function editAddressPointRequest(demandId, payload) {
  return buildApiRequest('PUT', `${urls.getDemands}/${demandId}/address`, payload);
}

export function editLaneNameRequest(demandId, payload) {
  return buildApiRequest('PUT', `${urls.getDemands}/${demandId}/laneName`, payload);
}
export function selectmapLocation(placeID, setSourceAsGoogle) {
  return buildApiRequest('GET', `${urls.selectMapLocation}?id=${placeID}`, { setSourceAsGoogle: setSourceAsGoogle });
}
